// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"3858f830","212":"c2a8f195","288":"db450c00","500":"e92ffda9","552":"2cea0b0e","592":"2b1ee153","688":"5f22eb0b","765":"1fd6a733"}[chunkId] + ".chunk.js";
};